@if (assistentOffen()) {
  <app-projekt-neu-assistent
    [projekte]="projekte()"
    [projekteZustand]="zustand()"
    (abbrechen)="assistentSchliessen()"
    (angelegt)="beiAngelegt($event)"
  />
} @else {
  <app-vw-kopf
    [titel]="'verwaltung.bereich.projekte.titel' | translate"
    [untertitel]="zustand() === 'bereit' ? ('verwaltung.projekte.zaehlung' | translate: zaehlung()) : ''"
  >
    <button type="button" class="vw-projekte__anlegen" data-testid="vw-projekt-anlegen" (click)="anlegen()">
      <span class="vw-projekte__plus" aria-hidden="true">＋</span>
      {{ 'verwaltung.projekte.anlegen' | translate }}
    </button>
  </app-vw-kopf>

  <div role="status">
    @if (angelegtesProjekt(); as neu) {
      <div class="vw-projekte__banner" data-testid="vw-projekt-banner">
        <mat-icon class="vw-projekte__banner-icon" aria-hidden="true">check</mat-icon>
        <span class="vw-projekte__banner-text">
          <strong>{{ 'verwaltung.projekte.banner.name' | translate: { name: neu.name } }}</strong>
          {{ 'verwaltung.projekte.banner.angelegt' | translate }}
          @if (neu.teamEingeladen) {
            {{ 'verwaltung.projekte.banner.eingeladen' | translate }}
          }
        </span>
        <a
          class="vw-projekte__banner-link"
          data-testid="vw-projekt-banner-link"
          [routerLink]="['/projects', neu.id, 'edit']"
        >
          {{ 'verwaltung.projekte.banner.oeffnen' | translate }}
          <span aria-hidden="true">↗</span>
        </a>
      </div>
    }
  </div>

  <div
    class="vw-projekte__karte"
    role="table"
    [attr.aria-label]="'verwaltung.projekte.tabelle' | translate"
    [attr.aria-busy]="zustand() === 'laedt' ? 'true' : null"
  >
    <div class="vw-projekte__raster vw-projekte__kopfzeile" role="row">
      <span class="vw-projekte__th" role="columnheader">{{ 'verwaltung.projekte.spalte.projekt' | translate }}</span>
      <span class="vw-projekte__th" role="columnheader">
        {{ 'verwaltung.projekte.spalte.verantwortlich' | translate }}
      </span>
      <span class="vw-projekte__th" role="columnheader">{{ 'verwaltung.projekte.spalte.status' | translate }}</span>
      <span class="vw-projekte__th" role="columnheader">
        <span class="cdk-visually-hidden">{{ 'verwaltung.projekte.spalte.aktionen' | translate }}</span>
      </span>
    </div>

    @switch (zustand()) {
      @case ('laedt') {
        @for (platzhalter of [1, 2, 3]; track platzhalter) {
          <div class="vw-projekte__platzhalter" role="row" aria-hidden="true"><span role="cell"></span></div>
        }
      }
      @case ('fehler') {
        <div role="row">
          <div class="vw-projekte__fehler" role="cell">
            <span>{{ 'verwaltung.projekte.ladefehler' | translate }}</span>
            <button type="button" class="vw-projekte__erneut" (click)="laden()">
              {{ 'verwaltung.projekte.erneut' | translate }}
            </button>
          </div>
        </div>
      }
      @default {
        @for (p of projekte(); track p.id) {
          @let archiviert = p.status === 'archiviert';
          @let statusAktion = archiviert ? 'wiederherstellen' : 'archivieren';
          @let verantwortlich = verantwortliche().get(p.id);
          <!-- Zeilenklick ist nur Maus-Komfort; Tastaturziel ist der Projektname-Link. -->
          <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
          <div
            class="vw-projekte__raster vw-projekte__zeile"
            [class.vw-projekte__zeile--archiviert]="archiviert"
            role="row"
            data-testid="vw-projekt-zeile"
            (click)="zeileOeffnen(p, $event)"
          >
            <span class="vw-projekte__zelle" role="cell">
              <a
                class="vw-projekte__name"
                data-testid="vw-projekt-name"
                [attr.data-projekt]="p.id"
                [routerLink]="['/projects', p.id, 'edit']"
                [title]="p.name"
              >
                {{ p.name }}
              </a>
            </span>
            <span class="vw-projekte__verantwortlich" role="cell" data-testid="vw-projekt-verantwortlich">
              @if (verantwortlich) {
                <app-avatar
                  [name]="verantwortlich.name"
                  [size]="26"
                  [neutral]="verantwortlich.unbekannt"
                  [initialen]="verantwortlich.unbekannt ? '?' : null"
                />
                <span class="vw-projekte__lead">{{ verantwortlich.name }}</span>
                @if (verantwortlich.weitere > 0) {
                  <span
                    class="vw-projekte__weitere"
                    data-testid="vw-projekt-weitere"
                    tabindex="0"
                    [matTooltip]="verantwortlich.alle"
                  >
                    <span aria-hidden="true">+{{ verantwortlich.weitere }}</span>
                    <span class="cdk-visually-hidden">
                      {{ 'verwaltung.projekte.weitere' | translate: { namen: verantwortlich.weitereNamen } }}
                    </span>
                  </span>
                }
              } @else {
                —
              }
            </span>
            <span class="vw-projekte__zelle" role="cell" data-testid="vw-projekt-status">
              @if (archiviert) {
                <span class="vw-projekte__archiviert">
                  <span class="vw-projekte__punkt" aria-hidden="true"></span>
                  {{ 'verwaltung.projekte.archiviert' | translate }}
                </span>
              } @else {
                <app-status-pill
                  [kind]="pillArt(p.status)"
                  [label]="p.status ? ('dashboard.filter.status_' + p.status | translate) : null"
                />
              }
            </span>
            <span class="vw-projekte__aktionen" role="cell">
              <button
                type="button"
                class="vw-projekte__knopf"
                data-testid="vw-projekt-archivieren"
                [attr.data-projekt]="p.id"
                [attr.aria-label]="('verwaltung.projekte.aktion.' + statusAktion | translate) + ' ' + p.name"
                (click)="fragen(p, statusAktion)"
              >
                {{ 'verwaltung.projekte.aktion.' + statusAktion | translate }}
              </button>
              <button
                type="button"
                class="vw-projekte__knopf vw-projekte__knopf--gefahr"
                data-testid="vw-projekt-loeschen"
                [attr.aria-label]="('verwaltung.projekte.aktion.loeschen' | translate) + ' ' + p.name"
                (click)="fragen(p, 'loeschen')"
              >
                {{ 'verwaltung.projekte.aktion.loeschen' | translate }}
              </button>
            </span>
          </div>
        } @empty {
          <div role="row">
            <div class="vw-projekte__leer" role="cell">{{ 'verwaltung.projekte.leer' | translate }}</div>
          </div>
        }
      }
    }
  </div>

  @let frage = rueckfrage();
  @let loeschen = frage?.aktion === 'loeschen';
  <app-confirm-dialog
    [visible]="!!frage"
    [title]="frage ? ('verwaltung.projekte.dialog.' + frage.aktion + '.titel' | translate) : ''"
    [message]="
      frage ? ('verwaltung.projekte.dialog.' + frage.aktion + '.text' | translate: { name: frage.projekt.name }) : ''
    "
    [confirmLabel]="frage ? ('verwaltung.projekte.dialog.' + frage.aktion + '.bestaetigen' | translate) : ''"
    [cancelLabel]="'common.cancel' | translate"
    [busy]="busy()"
    [icon]="loeschen ? 'delete' : 'edit'"
    [iconTon]="loeschen ? 'gefahr' : 'akzent'"
    [confirmColor]="loeschen ? 'warn' : 'primary'"
    (confirmed)="bestaetigen()"
    (cancelled)="abbrechen()"
  />
}
